import { z } from 'zod';

/** Odometer for clients is always km; persistence uses meters (ADR-0019). */
export const CustomerVehicleResponseSchema = z.object({
  id: z.uuid(),
  partyId: z.uuid(),
  vehicleId: z.uuid(),
  vehicleModelId: z.uuid(),
  brandId: z.uuid().nullable(),
  brandName: z.string().nullable(),
  modelName: z.string().nullable(),
  plate: z.string().nullable(),
  plateNormalized: z.string().nullable(),
  chassis: z.string().nullable(),
  color: z.string().nullable(),
  manufactureYear: z.number().int().nullable(),
  modelYear: z.number().int().nullable(),
  fipeCode: z.string().nullable(),
  vehicleGenerationId: z.uuid().nullable(),
  vehicleTrimId: z.uuid().nullable(),
  vehicleEngineId: z.uuid().nullable(),
  engineNumber: z.string().nullable(),
  engineNumberSource: z.enum(['LOOKUP', 'MANUAL']).nullable(),
  nickname: z.string().nullable(),
  notes: z.string().nullable(),
  acquiredAt: z.iso.date().nullable(),
  active: z.boolean(),
  currentMileageKm: z.number().nullable(),
  currentMileageRecordedAt: z.iso.datetime().nullable(),
  createdAt: z.iso.datetime(),
  updatedAt: z.iso.datetime(),
});

export type CustomerVehicleResponse = z.infer<typeof CustomerVehicleResponseSchema>;
